import React from 'react';
import { Box, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { ClassNameMap } from '@mui/styles';
import { useMessage } from 'modules/intl';

type CharacterCounterProps = {
  text?: string | null;
  totalChar: number;
  hasError: boolean;
  classes?: ClassNameMap;
};

const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: theme.typography.caption.fontFamily,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: theme.spacing(-1, 1, 1, 1)
  },
  counter: {
    color: theme.palette.text.secondary,
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto'
  },
  error: {
    color: theme.palette.error.main
  },
  totalCount: {
    whiteSpace: 'pre'
  }
}));

export const CharacterCounter: React.FC<CharacterCounterProps> = ({
  classes: overrideClasses,
  hasError,
  text,
  totalChar
}: CharacterCounterProps) => {
  const counter = (text || '').length;
  const classes = useStyles({ classes: overrideClasses });
  const errorMessage = useMessage('note.error.maxCommentLength');

  const errorState = hasError;
  return (
    <Box className={classes.root} data-testid="note-text-counter">
      <Box
        data-testid="text-counter"
        component="span"
        className={classes.counter}
      >
        <Typography
          variant="caption"
          component="span"
          className={errorState ? classes.error : ''}
        >
          {errorState ? `${errorMessage}: ${counter}` : counter}
        </Typography>
        <Typography
          variant="caption"
          className={classes.totalCount}
        >{` / ${totalChar}`}</Typography>
      </Box>
    </Box>
  );
};
